import http from '@/services/http-client';
import routes from '@/../config/env';

const { specialsService } = routes;

export const createSpecial = (payload) => http({
  method: 'post',
  url: `${specialsService}/specials`,
  data: payload,
});

export const updateSpecial = (payload) => http({
  method: 'put',
  url: `${specialsService}/specials`,
  data: payload,
});

export const resultSpecial = (payload) => http({
  method: 'post',
  url: `${specialsService}/specials/result`,
  data: payload,
});

export const importSpecialSelectionsPreview = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return http({
    method: 'post',
    url: `${specialsService}/specials/import-preview`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
};

export const calculateSpecialSelectionPrice = ({ probability, margin }) => http({
  method: 'post',
  url: `${specialsService}/specials/calculate-price`,
  data: {
    probability,
    margin,
    price: {
      priceType: 'american',
    },
  },
});

export const suspendSpecial = (specialId) => http({
  method: 'post',
  url: `${specialsService}/specials/suspend/${specialId}`,
});

export const unsuspendSpecial = (specialId) => http({
  method: 'post',
  url: `${specialsService}/specials/unsuspend/${specialId}`,
});

export const suspendSpecialSelection = (specialId, selectionId) => http({
  method: 'post',
  url: `${specialsService}/specials/${specialId}/selections/${selectionId}/suspend`,
});

export const unsuspendSpecialSelection = (specialId, selectionId) => http({
  method: 'post',
  url: `${specialsService}/specials/${specialId}/selections/${selectionId}/unsuspend`,
});

export const displaySpecialSelection = (specialId, selectionId) => http({
  method: 'post',
  url: `${specialsService}/specials/${specialId}/selections/${selectionId}/display`,
});

export const undisplaySpecialSelection = (specialId, selectionId) => http({
  method: 'post',
  url: `${specialsService}/specials/${specialId}/selections/${selectionId}/undisplay`,
});

export const displaySpecial = (specialId) => http({
  method: 'post',
  url: `${specialsService}/specials/display/${specialId}`,
});

export const undisplaySpecial = (specialId) => http({
  method: 'post',
  url: `${specialsService}/specials/undisplay/${specialId}`,
});

export const disableSpecial = (specialId) => http({
  method: 'post',
  url: `${specialsService}/specials/deactivate/${specialId}`,
});
